import { isEmptyObject } from '@sky-it-livedata-libraries/livedata-commons';
import { LgpPreviewQuery } from '../types';

/**
 * typeguard for LgpPreviewQuery
 * @param LgpPreviewQuery object passed to transformer
 */
export const isValidLgpPreview = (obj: LgpPreviewQuery): boolean => Boolean(obj?.data?.getLgpPreviewWidget && !isEmptyObject(obj.data.getLgpPreviewWidget));
